/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_Bundle_Offerscount1Inputs */

const id_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Penawaran`)
};

const ms_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Tawaran`)
};

const da_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Tilbud`)
};

const de_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Angebote`)
};

const en_us2_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Offers`)
};

const es_es2_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} ofertas`)
};

const es_mx2_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Ofertas`)
};

const fil_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Offer`)
};

const fr_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} offres`)
};

const it_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} offerte`)
};

const hu_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} ajánlat`)
};

const nl_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} aanbiedingen`)
};

const no_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} tilbud`)
};

const pl_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} ofert`)
};

const pt_br2_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Offers`)
};

const pt_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} ofertas`)
};

const ro_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} oferte`)
};

const fi_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} tarjousta`)
};

const sv_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} erbjudanden`)
};

const vi_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Ưu đãi`)
};

const tr_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Teklif`)
};

const cs_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} nabídek`)
};

const bg_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} оферти`)
};

const ru_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`— ${i?.count} предложений`)
};

const uk_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} пропозицій`)
};

const ar_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} عرض`)
};

const hi_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} ऑफ़र`)
};

const th_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} ข้อเสนอ`)
};

const ja_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} オファー`)
};

const zh_cn2_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Offers`)
};

const zh_hant1_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Offers`)
};

const ko_components_bundle_offerscount1 = /** @type {(inputs: Components_Bundle_Offerscount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`- ${i?.count} Offers`)
};

/**
* | output |
* | --- |
* | "- {count} Offers" |
*
* @param {Components_Bundle_Offerscount1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_bundle_offerscount1 = /** @type {((inputs: Components_Bundle_Offerscount1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Bundle_Offerscount1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_bundle_offerscount1(inputs)
	if (locale === "ms") return ms_components_bundle_offerscount1(inputs)
	if (locale === "da") return da_components_bundle_offerscount1(inputs)
	if (locale === "de") return de_components_bundle_offerscount1(inputs)
	if (locale === "en-US") return en_us2_components_bundle_offerscount1(inputs)
	if (locale === "es-ES") return es_es2_components_bundle_offerscount1(inputs)
	if (locale === "es-MX") return es_mx2_components_bundle_offerscount1(inputs)
	if (locale === "fil") return fil_components_bundle_offerscount1(inputs)
	if (locale === "fr") return fr_components_bundle_offerscount1(inputs)
	if (locale === "it") return it_components_bundle_offerscount1(inputs)
	if (locale === "hu") return hu_components_bundle_offerscount1(inputs)
	if (locale === "nl") return nl_components_bundle_offerscount1(inputs)
	if (locale === "no") return no_components_bundle_offerscount1(inputs)
	if (locale === "pl") return pl_components_bundle_offerscount1(inputs)
	if (locale === "pt-BR") return pt_br2_components_bundle_offerscount1(inputs)
	if (locale === "pt") return pt_components_bundle_offerscount1(inputs)
	if (locale === "ro") return ro_components_bundle_offerscount1(inputs)
	if (locale === "fi") return fi_components_bundle_offerscount1(inputs)
	if (locale === "sv") return sv_components_bundle_offerscount1(inputs)
	if (locale === "vi") return vi_components_bundle_offerscount1(inputs)
	if (locale === "tr") return tr_components_bundle_offerscount1(inputs)
	if (locale === "cs") return cs_components_bundle_offerscount1(inputs)
	if (locale === "bg") return bg_components_bundle_offerscount1(inputs)
	if (locale === "ru") return ru_components_bundle_offerscount1(inputs)
	if (locale === "uk") return uk_components_bundle_offerscount1(inputs)
	if (locale === "ar") return ar_components_bundle_offerscount1(inputs)
	if (locale === "hi") return hi_components_bundle_offerscount1(inputs)
	if (locale === "th") return th_components_bundle_offerscount1(inputs)
	if (locale === "ja") return ja_components_bundle_offerscount1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_bundle_offerscount1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_bundle_offerscount1(inputs)
	return ko_components_bundle_offerscount1(inputs)
});
export { components_bundle_offerscount1 as "components.bundle.offersCount" }